import {Link} from '@remix-run/react';
import React from 'react';
import logo from '~/assets/imgs/logo.svg?url';
interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  return (
    <div className="bg-ats-charcoal-100 text-white">
      <div className="flex justify-between px-8 py-2">
        <div className="flex items-center">
          <Link className="plain" to="/">
            <img
              src={logo}
              alt="Anderson Trucking Service"
              style={{minWidth: '59px'}}
            />
          </Link>
          <h1 className="ml-4 text-2xl font-bold">Load Tracker</h1>
        </div>
      </div>
    </div>
  );
};

export default Header;
